import { Injectable } from '@angular/core';
import { Gleap } from 'capacitor-gleap-plugin';

@Injectable({ providedIn: 'root' })
export class GleapService {

  constructor() { }

  closeChat() {
    Gleap.close();
  }

}